module.exports = __webpack_public_path__ + "img/bsales.7a3e3a5a.svg";